import $ from "jquery";

$(document).ready(function () {
    slidersHandler();
    $('.btn-scroll-top').on('click', function (event) {
        event.preventDefault();

        $("html, body").animate({
            scrollTop: $('.wrapper').offset().top
        }, 600);
    });
});

function initSlider($slider, options) {
    $slider.slick(options);
}

function slidersHandler() {
    const $sliderHero = $('.js-slider-hero');
    $sliderHero.each(function () {
        let $this         = $(this);
        let sliderOptions = {
            arrows        : true,
            infinite      : true,
            dots          : true,
            slidesToShow  : 1,
            slidesToScroll: 1,
            prevArrow     : $this.closest('.slider').find('.slider__prev'),
            nextArrow     : $this.closest('.slider').find('.slider__next')
        };
        initSlider($this, sliderOptions);
    });

    const $sliderUpdates = $('.js-slider-updates');
    $sliderUpdates.each(function () {
        let $this         = $(this);
        let sliderOptions = {
            arrows        : true,
            infinite      : true,
            dots          : false,
            slidesToShow  : 4,
            slidesToScroll: 1,
            prevArrow     : $this.closest('.slider').find('.slider__prev'),
            nextArrow     : $this.closest('.slider').find('.slider__next'),
            responsive    : [
                {
                    breakpoint: 992,
                    settings  : {
                        slidesToShow  : 3,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 850,
                    settings  : {
                        slidesToShow  : 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 650,
                    settings  : {
                        slidesToShow  : 1,
                        slidesToScroll: 1
                    }
                }
            ]
        };
        initSlider($this, sliderOptions);
    });
}
